import { render, staticRenderFns } from "./DetailEva.vue?vue&type=template&id=5d0777a4&scoped=true&"
import script from "./DetailEva.vue?vue&type=script&lang=js&"
export * from "./DetailEva.vue?vue&type=script&lang=js&"
import style0 from "./DetailEva.vue?vue&type=style&index=0&id=5d0777a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0777a4",
  null
  
)

export default component.exports